// Elements with this ID will be set to launch the Intercom flow
export const INTERCOM_BUTTON_ID = 'ai-profiles-page-evaluations-cta'
